<template>
  <div class="main-cates">
    <div class="block mobile" @click="enterPage('mobile')">
      <div class="title">手机</div>
      <div class="desc">入驻、续费、经营</div>
    </div>
    <div class="block non-mobile" @click="enterPage('non-mobile')">
      <div class="title">全部品类(除手机)</div>
      <div class="desc">入驻、续费、经营</div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'

export default {
  name: 'QuestionCategorySeller',
  methods: {
    enterPage(name) {
      lego.send({
        pagetype: 'ZZUP_HELPCENTER_SELLER',
        actiontype: 'ENTRY_CLICK',
        backup: {
          name
        }
      })

      let url = ''

      if (name === 'mobile') {
        url = 'https://feentry.zhuanzhuan.com/sja?clientid=kfzx_sj'
      } else if (name === 'non-mobile') {
        url = 'https://feentry.zhuanzhuan.com/sja?clientid=kfzx_fsj'
      }

      native.skipToUrl({
        targetUrl: url
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'QuestionCategory.less';
  @import '../HelpCenter.less';
</style>
